import React from 'react';
import { useAuth } from '../context/AuthContext';
import UserDashboard from './UserDashboard';
import AdminDashboard from './AdminDashboard';

const Dashboard = () => {
  const { user, isAdmin } = useAuth();

  if (!user) {
    return (
      <div className="container">
        <div className="card">
          <h2>Please log in to access your dashboard</h2>
        </div>
      </div>
    );
  }

  return (
    <div>
      {isAdmin() ? <AdminDashboard /> : <UserDashboard />}
    </div>
  );
};

export default Dashboard; 